import { render, staticRenderFns } from "./port-edit.vue?vue&type=template&id=881251b8&scoped=true&"
import script from "./port-edit.vue?vue&type=script&lang=js&"
export * from "./port-edit.vue?vue&type=script&lang=js&"
import style0 from "./port-edit.vue?vue&type=style&index=0&id=881251b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881251b8",
  null
  
)

export default component.exports